import template from '@naturehouse/design-system/components/protons/icon/Icon.html.njk';
import type { IconProps } from './Icon';

const IconComponent = (props: IconProps) => template.render(props);

export default IconComponent;
